import React from 'react';

const WorkingExperience = () => {
  const experiences = [
    {
      company: "Jardine Engineering Corporation",
      position: "Digital Business Solution Manager",
      period: "Jun 2023 – Present",
      badge: "Current",
      achievements: [
        "Lead a cross-functional team to deliver API integrations across internal and external platforms under the Azure Landing Zone framework",
        "Led the team to implement an AI project using a local AI server — the system reduced the commercial team's tender evaluation time by at least 50%",
        "Migrated the legacy website to Azure Cloud Native Stack (Web App, Function App, Cloud Database) for improved scalability and maintainability",
        "Migrated UIPath Robots to Power Automate Unattended Bots, simplifying the technical stack and reducing licensing complexity",
        "Led the team to implement operational reports powered by Power BI to visualise business data and accelerate decision-making",
        "Enhanced the Procurement System and Field Service System to improve process efficiency across business units",
        "Implemented a Cost Data Bank to consolidate historical quotation data and enhance estimation accuracy",
        "Migrated the on-premise Oracle Payroll system to Microsoft Azure, improving reliability and reducing infrastructure overhead",
        "Rolled out MS Planner and MS Loop to standardise IT task management across the department",
        "Replaced legacy paper name cards with a digital business card solution adopted company-wide",
        "Designed and shipped Generative AI solutions for multiple business scenarios — from document intelligence to workflow automation",
        "Revamped the enterprise Data Platform on the MS Azure stack, modernising data pipelines and reporting",
        "Evaluated and deployed a Staff Performance Management System aligned with HR transformation goals",
        "Own BAU support and continuous enhancement of the full digital solutions portfolio while mentoring team members"
      ]
    },
    {
      company: "Tricor Services Limited",
      position: "Senior Manager, Software Development Lead",
      period: "Sep 2022 – Apr 2023",
      badge: "Fintech",
      achievements: [
        "Maintained and enhanced the core backend system powering Investor Services for HK-listed companies",
        "Led mobile app improvements for the investor-facing platform",
        "Managed 5 local and offshore engineers plus two external vendors to modernise the core backend — cutting IPO settlement from T+5 to T+2"
      ]
    },
    {
      company: "Parsons Music Corporate",
      position: "Enterprise Applications Manager",
      period: "Apr 2016 – Sep 2022",
      badge: "6+ Years",
      achievements: [
        "Advised C-level executives on digital transformation strategy, shaping the group's technology roadmap",
        "Directed cross-functional projects spanning CRM, omni-channel commerce, online learning, and digital workplace",
        "Deployed Dynamics CRM (Sales Automation, Marketing Management, Customer Service Management) — adopted as the corporate-wide CRM backbone within 2 years",
        "Built a mobile-responsive B2B Portal on Dynamics CRM with ePayment integration, replacing manual WeChat and email order workflows",
        "Extended the CRM platform to WeChat and WeCom for loyalty programs and managed customer communications",
        "Launched an HK eCommerce site — replaced a content-only website with a conversion-driven sales platform",
        "Rolled out a Mobile Workplace Solution on Kingdee, standardising clock-in/out, approvals, and internal comms across retail operations",
        "Led 15 engineers across Mainland China and Germany to build an Online Learning Platform featuring interactive sheet music, music creation tools, and wiki content",
        "Delivered a Learning Centre Management Platform with a 15-person cross-border team — covering student payments, timetables, homework submission, and teacher management",
        "Initiated a full revamp of retail management and Customer Service Management systems",
        "Implemented ITIL-based IT service management using ManageEngine, extending the service desk to support corporate mobile workplace"
      ]
    },
    {
      company: "ACW Solutions Ltd.",
      position: "Project Manager",
      period: "Nov 2014 – Feb 2016",
      achievements: [
        "Scoped and pitched MS SharePoint and Dynamics CRM solutions — from prototypes through to proposals and quotations",
        "Architected solution designs based on client requirements and delivered effort estimates",
        "Delivered a Corporate Intranet on MS SharePoint for a marketing, investment, and distribution organisation",
        "Built a Document Management system on MS SharePoint with Kodak scanning integration for a HK university",
        "Enhanced a Policy Quotation System on MS Dynamics CRM for a HK insurance company"
      ]
    },
    {
      company: "Sun Hung Kai Real Estate Agent Ltd",
      position: "Analyst Programmer",
      period: "May 2013 – Aug 2014",
      achievements: [
        "Implemented MySite and departmental portals on the existing Corporate Intranet",
        "Designed and shipped a Corporate Extranet extending Intranet access to subsidiary companies",
        "Established 24/7 high-availability Azure web hosting to meet Residential Properties Ordinance compliance requirements"
      ]
    },
    {
      company: "Tectura Hong Kong Ltd",
      position: "Senior Consultant",
      period: "Sep 2011 – Apr 2013",
      achievements: [
        "Delivered a Corporate Website CMS for a hotel group on MS SharePoint",
        "Built a Case Management System on MS Dynamics CRM for a telecommunications company",
        "Implemented a Sales Automation System integrating MS Dynamics CRM with MS NAV ERP for a toys trading company"
      ]
    },
    {
      company: "The Hongkong Electric Co., Ltd",
      position: "Associate IT Specialist",
      period: "Sep 2007 – Sep 2011",
      badge: "4 Years",
      achievements: [
        "Revamped legacy systems for IT Service Desk, Production Control, and Data Centre operations",
        "Drove IT Operations service transformation aligned with the ITIL framework",
        "Established an application and operations framework on MS SharePoint 2007 for Corporate Intranet and digital workspace",
        "Built an HR succession planning system on MS SharePoint 2007 with Rights Management Service"
      ]
    },
    {
      company: "AuPosford Consultants Ltd.",
      position: "Analyst Programmer",
      period: "Jul 2006 – Sep 2007",
      achievements: [
        "Developed a Facility Maintenance system on GIS for the HKSAR Civil Department",
        "Delivered IT facility health-checking services to the HKSAR Lands Department"
      ]
    }
  ];

  return (
    <div>
      {experiences.map((exp, index) => (
        <div key={index} className="experience-card">
          <div className="experience-header">
            <div>
              <div className="experience-company">{exp.company}</div>
              <div className="experience-role">{exp.position}</div>
            </div>
            <span className="experience-period">{exp.period}</span>
          </div>
          {exp.badge && <span className="experience-badge">{exp.badge}</span>}
          <ul className="experience-list">
            {exp.achievements.map((achievement, idx) => (
              <li key={idx}>{achievement}</li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};

export default WorkingExperience;
